import { SolidButton } from "../../global/SolidButton";
import { Calendar1, Filter, User, UserPlus } from "lucide-react";
import { getAppUsers } from "./api";
import MyLoader from "../../util/MyLoader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { MyModal } from "../../global/MyModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Pagination from "../../util/Pagination";
import { Fragment, useEffect, useState } from "react";

export default function Users() {
  // pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [total, setTotal] = useState(0);
  //filter
  const [search, setSearch] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [referrar, setReferrar] = useState("");
  const [referCode, setReferCode] = useState("");
  const [orderBy, setOrderBy] = useState("dateTime");
  const [orderDirection, setOrderDirection] = useState("DESC");

  //data
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenCal, setIsOpenCal] = useState(false);
  // actual applied value
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const setDateRange = (update) => {
    const [start, end] = update;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      setIsOpenCal(false);
    }
  };

  const { id } = useParams();

  const type = [
    { id: 1, label: "Active", value: "active" },
    { id: 2, label: "Inactive", value: "inactive" },
    { id: 3, label: "Blocked", value: "blocked" },
  ];

  const [activeTab, setActiveTab] = useState(1);
  const navigate = useNavigate();

  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/apps/${id}/users?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get("status");
    const found = type.find((item) => item.value === status);
    if (found) setActiveTab(found.id);
  }, [searchParams]);

  //Search
  useEffect(() => {
    if (search.endsWith(" ")) {
      setPage(1);
    }
  }, [search]);

  //api
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await getAppUsers({
        status: type[activeTab - 1].value,
        search: appliedSearch,
        referrer: referrar,
        refer: referCode,

        orderBy: orderBy,
        orderDirection: orderDirection,
        page: page,
        limit: limit,
        fromDate: startDate,
        toDate: endDate,
      });
      if (res.status === 200) {
        console.log(res?.data);
        setUsers(res.data?.users || []);
        setTotal(res.data?.totalRows || 0);
      }
    } catch (err) {
      console.error("failed to fetch data :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchUsers();
    }, 400);

    return () => clearTimeout(timer);
  }, [page, limit, appliedSearch, activeTab]);

  const applyFilter = async () => {
    setPage(1);
    fetchUsers();
    setIsModalOpen(false);
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4 w-full relative">
        <div className="flex items-center justify-between h-auto ">
          {/* tabs */}
          <div className=" flex items-center justify-between">
            <div className="flex items-center gap-2 px-2 py-2 bg-slate-300/25 dark:bg-slate-900/80 backdrop-blur-xl rounded-lg">
              {type.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`text-xs px-3 py-1.5 rounded-md transition-all duration-200 
        ${
          tab.id === activeTab
            ? "bg-white dark:bg-slate-800 text-black dark:text-white shadow-sm"
            : "text-slate-600 dark:text-slate-400 hover:bg-white/50 dark:hover:bg-slate-800/50"
        }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <SolidButton
            className="py-1 h-[30px]   px-2   "
            onClick={() => setIsModalOpen(true)}
          >
            <Filter size={14} />
            <span>Filter</span>
          </SolidButton>
        </div>
        {/* table */}
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto       
               mt-4 
              "
        >
          <div className="overflow-x-auto">
            {/* Search Outside Table */}
            <div className="my-4 px-4">
              <input
                type="search"
                placeholder="Search by name,email,label..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setPage(1);
                    setAppliedSearch(search.trim());
                  }
                }}
                className="w-full md:w-80 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              />
            </div>
            <table className="w-full text-xs text-left">
              <thead>
                <tr className="border-b border-slate-300/40 text-slate-600 dark:text-slate-400">
                  <th className="px-4 py-3 font-semibold min-w-[200px]">
                    users
                  </th>
                  <th className="px-4 py-3 font-semibold text-start">
                    Refer Code
                  </th>
                  <th className="pl-6 py-3 font-semibold text-start">Coins</th>
                  <th className="pl-14 py-3 font-semibold text-start">
                    Referrer
                  </th>
                  <th className="pl-20 py-3 font-semibold text-start">
                    Date Of Joining
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr
                    key={index}
                    className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40 "
                  >
                    {/* User */}
                    <td className="px-4 py-3">
                      <div
                        onClick={() => navigate(`/apps/${id}/users/${user.id}`)}
                        className="flex items-center cursor-pointer gap-3"
                      >
                        {user.image ? (
                          <img
                            className="w-8 h-8 rounded-full object-cover"
                            src={user.image}
                            referrerPolicy="no-referrer"
                            alt="profile"
                          />
                        ) : (
                          <User className="w-8 h-8 p-1 dark:text-white dark:bg-slate-400 bg-slate-200 text-slate-600 rounded-full" />
                        )}
                        <div>
                          <p className="text-xs font-semibold text-slate-800 dark:text-slate-300">
                            {user.name}
                          </p>
                          <p className="text-[10px] text-slate-500">
                            {user.uuid}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="text-start  text-xs px-4 text-slate-800 dark:text-slate-400 font-mono font-semibold ">
                      {user.refer_code}
                    </td>
                    <td className="text-start  text-xs pl-6 text-slate-800 dark:text-slate-400 font-mono font-semibold ">
                      {user.coins}
                    </td>
                    <td className="text-start   pl-14  ">
                      <div className="flex flex-col">
                        {user.referrer != "" && (
                          <span
                            onClick={() =>
                              navigate(
                                `/apps/${id}/users/${user.referrer_user_id}`,
                              )
                            }
                            className="text-slate-700 dark:text-slate-200 cursor-pointer text-xs font-semibold"
                          >
                            {user.referrer_name}
                          </span>
                        )}

                        <span className="text-slate-800 dark:text-slate-400 font-mono font-medium">
                          {user.referrer == "" ? "-" : user.referrer}
                        </span>
                      </div>
                    </td>
                    <td className="text-start text-xs px-20 text-slate-800 dark:text-slate-400 font-sans font-semibold ">
                      {user.datetime}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="w-full b-0 absolute">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      {/* Filter */}
      <MyModal
        title={"User Filters"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        width="460px"
      >
        <div className="space-y-2 w-full">
          {/* Date picker */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Date Range*
            </label>

            <div
              className="relative cursor-pointer"
              onClick={() => {
                console.log("Open date picker");
                setIsOpenCal(true);
              }}
            >
              {/* Icon */}
              <Calendar1
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none"
                size={16}
              />

              {/* Input */}
              <input
                type="text"
                placeholder="Pick Date Range"
                value={
                  startDate && endDate
                    ? `${format(startDate, "dd MMM yyyy")} ~ ${format(endDate, "dd MMM yyyy")}`
                    : ""
                }
                readOnly
                className="w-full text-xs py-2.5 pl-9 pr-3 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
              />
            </div>
            {isOpenCal && (
              <div className="absolute left-4 top-32">
                <DatePicker
                  selected={startDate}
                  onChange={(update) => {
                    const [start, end] = update || [];

                    const startDateFixed = start
                      ? new Date(
                          start.getFullYear(),
                          start.getMonth(),
                          start.getDate(),
                          0,
                          0,
                          0,
                          0,
                        )
                      : null;

                    const endDateFixed = end
                      ? new Date(
                          end.getFullYear(),
                          end.getMonth(),
                          end.getDate(),
                          23,
                          59,
                          59,
                          999,
                        )
                      : null;

                    setDateRange([startDateFixed, endDateFixed]);

                    console.log("fromDate", startDateFixed?.toISOString());
                    console.log("toDate", endDateFixed?.toISOString());
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  inline
                  maxDate={new Date()}
                  calendarClassName="  !shadow-xl !bg-slate-200 dark:!bg-slate-600"
                />
              </div>
            )}
          </div>
          {/* referrer code */}

          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Referrer Code*
            </label>

            {/* Input */}
            <input
              type="text"
              placeholder="Search by referrer code.."
              value={referrar}
              onChange={(e) => setReferrar(e.target.value)}
              className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
            />
          </div>
          {/* refer code */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Refer Code*
            </label>

            {/* Input */}
            <input
              type="text"
              placeholder="Search by refer code.."
              value={referCode}
              onChange={(e) => setReferCode(e.target.value)}
              className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
            />
          </div>
          {/* sorting */}
          <label className="block text-xs font-semibold dark:text-slate-300 text-slate-700 mt-4">
            sorting*
          </label>
          {/* Sort By and Order by*/}
          <div className="w-full grid grid-cols-2 gap-4">
            {/* Sort By */}
            <div className="flex flex-col col-span-1">
              <label className=" text-xs  font-medium text-black-600 dark:text-slate-500 ">
                Sort By
              </label>
              <select
                name="sortBy"
                value={orderBy}
                //  defaultValue={"razorpay"}

                onChange={(e) => {
                  setOrderBy(e.target.value);
                }}
                placeholder="Enter Gateway Name"
                id=""
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
              >
                <option value="dateTime">Joined Date</option>
                <option value="coins">Coins</option>
                <option value="name">Name</option>
              </select>
            </div>
            {/* Order */}
            <div className="flex flex-col col-span-1">
              <label className=" text-xs  font-medium text-black-600 dark:text-slate-500  ">
                Order
              </label>
              <select
                name="order"
                value={orderDirection}
                //  defaultValue={"razorpay"}

                onChange={(e) => {
                  setOrderDirection(e.target.value);
                }}
                placeholder="order "
                id=""
                className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
              >
                <option value="ASC">Ascending</option>
                <option value="DESC">Descending</option>
              </select>
            </div>
          </div>
          {/* line */}
          <div className="bg-slate-500/20 dark:bg-slate-400/20  w-full h-[1px] mt-4" />

          <div className="flex items-center justify-between space-x-4 mt-4 ml-auto">
            <span
              onClick={() => {
                setDateRange(["", ""]);
                setReferrar("");
                setOrderBy("dateTime");
                setOrderDirection("DESC");
              }}
              className="dark:text-slate-400 text-slate-500 text-xs cursor-pointer py-2 pr-2"
            >
              Reset
            </span>
            <button
              className="px-4 py-2 rounded-lg
                      bg-slate-400/20 dark:bg-slate-800 
                      text-slate-800 dark:text-slate-300 text-sm font-semibold
                      hover:bg-slate-400/30 dark:hover:bg-slate-700 
                      transition-all duration-300 ml-auto"
              onClick={() => {
                setIsModalOpen(false);
                // setErrors({});
              }}
            >
              Cancel
            </button>
            <SolidButton
              children={<span>Apply Filters</span>}
              onClick={() => {
                applyFilter();
              }}
            />
          </div>
        </div>
      </MyModal>
    </Fragment>
  );
}
